module.exports = __webpack_public_path__ + "static/img/dark.412ca67e.svg";